import { render, staticRenderFns } from "./SubcommissionAllocation.vue?vue&type=template&id=7f15480e&scoped=true"
import script from "./SubcommissionAllocation.vue?vue&type=script&lang=js"
export * from "./SubcommissionAllocation.vue?vue&type=script&lang=js"
import style0 from "./SubcommissionAllocation.vue?vue&type=style&index=0&id=7f15480e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f15480e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f15480e')) {
      api.createRecord('7f15480e', component.options)
    } else {
      api.reload('7f15480e', component.options)
    }
    module.hot.accept("./SubcommissionAllocation.vue?vue&type=template&id=7f15480e&scoped=true", function () {
      api.rerender('7f15480e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/creatApp/components/SubcommissionAllocation.vue"
export default component.exports